import { Component, EventEmitter, Input, Output, OnInit, ViewChild} from "@angular/core";
import { BaseError } from "../../../../../base-error";
import { ResizeEvent } from "angular-resizable-element";
import { environment } from "../../../../../../../../environments/environment";
import {Store} from "../../../../../../../services/store.service";
import { ToastrService } from "ngx-toastr";
import { DeterminantNewComponent } from "src/app/components/pages/registrations/components/determinant/determinant-new.component";

@Component({
    selector: "data-transformations",
    templateUrl: "./data-transformations.component.html",
})

export class DataTransformationsComponent extends BaseError {

    @Input() public selectedLink: any;
    @Output("saveTransformation") public saveTransformation: EventEmitter<any> = new EventEmitter();
    @Output("closeLayer") public closeLayer: EventEmitter<any> = new EventEmitter();
    @Input() public switchs: any = {};
    @Input() public serviceId: any;
    public sortByFields: any[] = [];
    public fields: any[] = [];
    public distinctByFields: any[] = [];
    public groupByFields: any[] = [];
    public inputTransformations: string[] = [];
    public isGridTransformation: boolean = false;
    public isGroupByEligible: boolean = false;
    public jsonDeterminant: any;
    public jsonDeterminantFilter: any;
    public transformations = {
        sortByFields: this.sortByFields,
        useAsStartsWith: false,
        useAsExactSearch: false,
        useAsFullTextSearch: false,
        distinctByFields: [],
        groupByFields: [],
        inputTransformations: this.inputTransformations,
    };
    public style: object = {};

    @ViewChild(DeterminantNewComponent) public determinantNewComponent: DeterminantNewComponent;

    constructor(public store: Store, toastr: ToastrService) { super(toastr); }

    public ngOnInit(): void {
        console.log(this.selectedLink, this.switchs);
        this.isGridTransformation = this.selectedLink?.item?.field?.input?.type === "editgrid" || this.selectedLink?.item?.field?.input?.type === "datagrid";
        this.isGroupByEligible = this.getGroupByEligibility(this.selectedLink?.item?.field?.input, this.switchs.lines);
        if (!this.selectedLink.isLtr) {
            if (this.switchs.item?.jsonDeterminant) {
                this.jsonDeterminant = this.switchs.item?.jsonDeterminant;
            }
            if (this.switchs.item?.jsonDeterminantFilter) {
                this.jsonDeterminantFilter = this.switchs.item?.jsonDeterminantFilter;
            }
            if (this.switchs.item?.targetFieldProperties?.inputTransformations) {
                this.inputTransformations = this.switchs.item.targetFieldProperties?.inputTransformations;
            }
        } else {
            if (this.switchs.item?.field?.jsonDeterminant) {
                this.jsonDeterminant = this.switchs.item?.field?.jsonDeterminant;
            }
            if (this.switchs.item?.field?.jsonDeterminantFilter) {
                this.jsonDeterminantFilter = this.switchs.item?.field?.jsonDeterminantFilter;
            }
            if (this.switchs.item?.field?.targetFieldProperties?.inputTransformations) {
                this.inputTransformations = this.switchs.item.field.targetFieldProperties.inputTransformations;
            }
        }
        if (this.switchs.item?.field?.targetFieldProperties?.distinctByFields) {
            this.distinctByFields = this.switchs.item?.field?.targetFieldProperties?.distinctByFields;
        }
        if (this.switchs.item?.field?.targetFieldProperties?.groupByFields) {
            this.groupByFields = this.switchs.item?.field?.targetFieldProperties?.groupByFields;
        }
    }

    public saveDeterminant() {
        this.determinantNewComponent.save();
    }

    public getGroupByEligibility(item, lines): boolean {
        if (item && item.fieldKey && lines) {
            const parent = item.fieldKey.substring(0, item.fieldKey.lastIndexOf("_collection_"));
            const parentIsMapped = lines.find((l) => {
                return l.end === `to${parent}`
                    && l.targetFieldProperties?.groupByFields?.length
                    && l.targetFieldProperties?.inputTransformations?.length
                    && l.targetFieldProperties?.inputTransformations[0] === "groupBy";
            });
            console.log(item.fieldKey, parent, parentIsMapped, item.type, parent && parentIsMapped && item.type === "number");
            return parent && parentIsMapped && item.type === "number";
        }
        return false;
    }

    public closeSection(event) {
        this.closeLayer.emit(event);
    }

    public onResizeEnd(event: ResizeEvent) {
        this.style = {
          width: `${event.rectangle.width}px`,
        };
    }

    public updateDeterminant(event) {
        this.switchs.item.field.jsonDeterminant = JSON.parse(event.jsonString);
    }

    public updateDeterminantFilter(event) {
        this.switchs.item.field.jsonDeterminantFilter = JSON.parse(event.jsonString);
    }

    public haveMultipleRelations(): boolean {
        if (this.switchs.lines && this.switchs.lines.length) {
            const fields = this.switchs.lines.filter((line) => line.end === this.switchs.item.field.end);
            return fields.length > 1;
        }
        return false;
    }

    public enableInputTransformations(): boolean {
        return Boolean(environment.INPUT_TRANSFORMATIONS_ENABLED) && !this.haveMultipleRelations();
    }

    public isNumberRelationship(): boolean {
        if (this.switchs && this.switchs.item && this.switchs.item.field && this.switchs.item.field.field && this.switchs.item.field.input) {
            return (this.switchs.item.field.field.type === "number") || (this.switchs.item.field.input.type === "number") || (this.switchs.item.field.field.type === "integer") || (this.switchs.item.field.input.type === "integer");
        } else {
            return true;
        }
    }

    public updateDistinctByField(event) {
        this.distinctByFields = event;
    }

    public updateGroupByField(event) {
        this.groupByFields = event;
    }

    public closeEdit() {
        this.store.state.common.determinantSection.reset();
    }

    public updateTransformations(event) {
        this.inputTransformations = event;
    }

    public save() {
        this.fields.forEach((field, i) => {
          this.sortByFields.push({
            id: field.id,
            transformation: (!field.uppercase && !field.lowercase) ? "" : (field.uppercase ? "uppercase" : "lowercase"),
            separator: field.separator,
            order: i,
          });
        });
        this.transformations.distinctByFields = this.distinctByFields;
        this.transformations.groupByFields = this.groupByFields;
        this.transformations.sortByFields = this.sortByFields;
        this.transformations.inputTransformations = this.haveMultipleRelations() ? [] : this.inputTransformations;
        // console.log(this.transformations, this.inputTransformations);
        this.saveTransformation.emit(
            {
                data: this.transformations,
                switchs: this.switchs,
                distinctByFields: this.distinctByFields,
                groupByFields: this.groupByFields,
                jsonDeterminant: this.switchs.item.field.jsonDeterminant,
                jsonDeterminantFilter: this.switchs.item.field.jsonDeterminantFilter,
            },
        );
    }
}
